<div class="layout-main">
  <div class="container-fluid">
    <div class="row">
      <div class="pb-2 mb-3 border-bottom col-12">
        <h2>
          <b>BW Monitoring strategies</b>
        </h2>
      </div>
    </div>
    <div class="d-flex flex-wrap"></div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <span class="filter-title p-panel-title"><i class="fa fa-search"></i> Filter</span>
          </ng-template>
          <div class="row">
            <div class="form-group col-2">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="bwMonitoringFilterCriteria.originPop"
                            [filter]="true"
                            [options]="originPopList"
                            [showClear]="true"
                            placeholder="ALL">
                </p-dropdown>
                <label>Origin Pop</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-2">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="bwMonitoringFilterCriteria.destinationPop"
                            [filter]="true"
                            [options]="destinationPopList"
                            [showClear]="true"
                            placeholder="ALL">
                </p-dropdown>
                <label>Destination Pop</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-2">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="bwMonitoringFilterCriteria.vvlanId"
                            [filter]="true"
                            [options]="vvlanIdList"
                            [showClear]="true"
                            placeholder="ALL">
                </p-dropdown>
                <label>VvlanId</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-2">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()"
                            [(ngModel)]="bwMonitoringFilterCriteria.uniqId"
                            [filter]="true"
                            [options]="uniqIdList"
                            [showClear]="true"
                            placeholder="ALL">
                </p-dropdown>
                <label>UniqId</label>
              </p-floatLabel>
            </div>
            <div class="col-2">
              <p-floatLabel>
                <p-calendar (onSelect)="filter()" [(ngModel)]="bwMonitoringFilterCriteria.dateFrom"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
                </p-calendar>
                <label>Last updated from</label>
              </p-floatLabel>
            </div>
            <div class="col-2">
              <p-floatLabel>
                <p-calendar (onSelect)="filter()" [(ngModel)]="bwMonitoringFilterCriteria.dateTo"
                            [showIcon]="true" dataType="string" dateFormat="mm/dd/yy">
                </p-calendar>
                <label>Last updated to</label>
              </p-floatLabel>
            </div>
          </div>
          <div class="row">
            <div class="col-12 float-right">
              <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" label="Reset"
                      pButton
                      style="float:right; margin-left: 5px" type="button"></button>
              <button (click)="addBwGraph()" *roles="['ROLE_MCKAY_SUPER']" class="float-right"
                      icon="fa fa-plus-circle pr-2"
                      iconPos="left"
                      label="Add bw graph" pButton type="button">
              </button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div *ngIf="!loading" class="row mt-3">
      <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
        {{ this.errorMessage }}
        <button (click)="error = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="!loading" class="col-12">
        <div *ngIf="successDelete" class="alert alert-success alert-dismissible fade show">
          BW graph has been deleted.
          <button (click)="successDelete = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="filtredBwGraph.length > 0" class="col-12 p-0">
          <p-table #dataTable [columns]="cols" [paginator]="true" [rowHover]="true" [rows]="30" [value]="filtredBwGraph"
                   editMode="row">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                  {{ col.header }}
                  <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-bwGraph pTemplate="body">
              <tr>
                <td>
                  <div style="overflow: hidden; text-overflow: ellipsis;">
                    <span [pTooltip]="technicalPopService.getCageTooltip(bwGraph?.originPop)">
                      {{ bwGraph?.originPop }}
                    </span>
                  </div>
                </td>
                <td>
                  <div style="overflow: hidden; text-overflow: ellipsis;">
                    <span [pTooltip]="technicalPopService.getCageTooltip(bwGraph?.destinationPop)">
                      {{ bwGraph?.destinationPop }}
                    </span>
                  </div>
                </td>
                <td>
                  <div style="overflow: hidden; text-overflow: ellipsis;">{{ bwGraph?.vvlanId }}</div>
                </td>
                <td>
                  <div style="overflow: hidden; text-overflow: ellipsis;">{{ bwGraph?.uniqId }}</div>
                </td>
                <td>
                  <div
                    style="overflow: hidden; text-overflow: ellipsis;">{{ bwGraph?.lastUpdated | date : 'MMM dd, y hh:mm' }}
                  </div>
                </td>
                <td *roles="['ROLE_MCKAY_SUPER']">
                  <button (click)="editBwGraph(bwGraph)"
                          class="btn btn-link no-padding-button"
                          type="button">
                    <i aria-hidden="true" class="fa fa-pencil icon-color"></i>
                    <span> Edit</span>
                  </button>
                  <br>
                  <button (click)="delete(bwGraph)" class="btn btn-link no-padding-button ng-star-inserted"
                          type="button">
                    <i aria-hidden="true" class="fa fa-close icon-color"></i>
                    <span> Delete</span>
                  </button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div *ngIf="records !== 1">
                {{ records }} results
              </div>
            </ng-template>
            <ng-template pTemplate="summary">
              <div *ngIf="records === 1">
                {{ records }} result
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
